import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { GetCategoryListDataTypes } from "../../../../Schema/getCategoryList.types";
import { categories } from "../../../../Constants/categories";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";

export type GetCategoryListLoadAction = {
  type: string;
  payload: {};
};

export type GetCategoryListData = {
  data: GetCategoryListDataTypes[];
};

const GetCategoryList = new ReduxFetchState<GetCategoryListData, {}, any>("getCategoryList");

export function* watchGetCategoryList(action: GetCategoryListLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    // const queryClient: QueryClient = yield getContext("queryClient");

    // const data: GetCategoryListData = yield call([queryClient, queryClient.fetchQuery], {
    //   queryKey: ["categories", lang],
    //   queryFn: async () => {
    //     const res = await axios({
    //       url: "/api/v1/ai/category/list",
    //       method: "GET",
    //       headers: { lang },
    //     });
    //     return { data: res.data };
    //   },
    //   staleTime: 60 * 60 * 1000,
    // });

    yield put(GetCategoryList.actions.loadSuccess({ data: categories[lang] }));
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(GetCategoryList.actions.loadFailure(e.message));
  }
}

export function* getCategoryListSagas() {
  yield takeEvery(GetCategoryList.actionTypes.load, watchGetCategoryList);
}

export function useGetCategoryList() {
  const { loading, data, ...getCategoryListState } = useAppSelector(
    (state) => state.getCategoryList,
  );
  const dispatch = useAppDispatch();

  const dispatchGetCategoryList = useCallback(() => {
    dispatch(GetCategoryList.actions.load());
  }, [dispatch]);

  return {
    ...getCategoryListState,
    dispatchGetCategoryList,
    getCategoryListLoading: loading,
    getCategoryListData: data,
  };
}

export const {
  actionTypes: getCategoryListActionsTypes,
  actions: getCategoryListActions,
  reducer: getCategoryListReducer,
} = GetCategoryList;
